import { OrderAddressData } from "services/interface";
import styled from "@emotion/styled";
import {  Col, Form, FormInstance, Row, Switch, Typography } from "antd";
import { FC } from "react";
import AgentDescriptionForm from "./AgentDescriptionForm";
import AgentAddressForm from "./AgentAddressForm";
import { useAppSelector } from "store";

interface MainCreateAgentProps {
  form: FormInstance;
  masterProviceData: any;
  dataAddress?: OrderAddressData;
}

const MainCreateAgent: FC<MainCreateAgentProps> = ({
  form,
  masterProviceData,
  dataAddress,
}) => {

  const { contact } = useAppSelector((state) => state.auth);
  return (
  <>
    <FormWrapper>
      <FormItemWrapper>
        <HeadWrapper>
          <Typography.Text 
            style={{
              fontWeight: 600,
            }}
            underline >{contact?.code === "lunganek" ? "ข้อมูลตัวแทน" : "ข้อมูลลูกค้า"}</Typography.Text>
        </HeadWrapper>
        <Row style={{ backgroundColor: "#EFEFEFEF" }}>
            <Col span={12}>
                <AgentDescriptionForm form={form} />
            </Col>
            <Col span={12}>
                <AgentAddressForm form={form} is_active={false} masterProviceData={masterProviceData} dataAddress={dataAddress}/>
            </Col>
        </Row>
      </FormItemWrapper>
    </FormWrapper>
  </>
  );
};

export default MainCreateAgent;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 10px 0px 10px;
`;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
  
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 10px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

